module.exports = __webpack_public_path__ + "static/media/banner_mobil.0493d272.png";